import mitt, { Emitter, Handler } from "mitt";

enum EVENTS {
  SET_EMAIL = "set_email"
}

/** Payload trasportato da ciascun evento del bus. */
type EventPayloads = {
  /** Email di notifica attualmente salvata, usata per prepopolare la modale di conferma. */
  [EVENTS.SET_EMAIL]: string | null
};

let emit: Emitter<EventPayloads> | null = null;

function getInstance(): Emitter<EventPayloads> {
  if (!emit)
    emit = mitt<EventPayloads>();

  return emit;
}

function sendEvent<K extends keyof EventPayloads>(event: K, data: EventPayloads[K]) {
  getInstance().emit(event, data);
}

function subscribeEvent<K extends keyof EventPayloads>(event: K, handler: Handler<EventPayloads[K]>) {
  getInstance().on(event, handler);
}

export {
  EVENTS,
  sendEvent,
  subscribeEvent
};
